import {
    apiRequest,
    AwardTypeList,
    AwardPeriodDetail,
    AwardReload,
    AwardPeriodExport
} from "../../../../../services/adapters/kepegawaian/penghargaanService"

class IndexRepository {

    fetchAwardList = async (query, cancelToken) => {
        return await apiRequest("get", AwardTypeList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchDetail = async (query, cancelToken) => {
        return await apiRequest("get", AwardPeriodDetail, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchReload = async (query) => {
        return await apiRequest("post", AwardReload, {
            body: query
        }, true)
    }

    fetchExport = async (query) => {
        return await apiRequest("get", AwardPeriodExport, {
            params: query
        }, true)
    }

}

export default IndexRepository;